/**
 * RequireRole — rol bo'yicha sahifa himoyasi.
 *
 * EGASI/ADMIN'gina ko'radigan sahifalarni o'rab turadi. Ruxsati yo'q
 * foydalanuvchi (masalan XODIM yoki impersonate qilingan XODIM) bu sahifaga
 * URL orqali kirsa — /kassa'ga yo'naltiriladi (oq sahifa/crash o'rniga).
 *
 * PLATFORM_ADMIN uchun alohida fallback: storeId yo'q bo'lgani sababli /kassa
 * ishlaydi emas — /stores'ga yo'naltiriladi.
 *
 * Sidebar allaqachon rol bo'yicha menyularni yashiradi; bu — to'g'ridan-to'g'ri
 * URL yoki impersonate holatida ham himoya (server RLS bilan bir qatorda).
 */
import type { UserRole } from '@avtofix/shared';
import { Navigate, Outlet } from 'react-router';

import { useCurrentUser } from '@/features/auth/auth.hooks';

export function RequireRole({ allow }: { allow: UserRole[] }): React.ReactElement {
  const user = useCurrentUser();
  // user null bo'lsa (hali yuklanmoqda) — bloklamaymiz. Rol ma'lum bo'lib,
  // ruxsat yo'q bo'lsa — fallback sahifaga yo'naltiramiz.
  if (user !== null && !allow.includes(user.role)) {
    // Har bir maxsus rol uchun to'g'ri landing sahifa
    let fallback = '/kassa';
    if (user.role === 'PLATFORM_ADMIN') fallback = '/stores';
    else if (user.role === 'PICKUP_OPERATOR') fallback = '/pickup-operator';
    else if (user.role === 'COURIER') fallback = '/courier';
    return <Navigate to={fallback} replace />;
  }
  return <Outlet />;
}
